<template>
  <div class="field-controls">
    <button type="button"
            @click="elementsScale"
            class="zoom-btn control-btn shadow">
      <img src="../../../../assets/zoom.svg" v-if="!activeZoom">
      <img src="../../../../assets/zoomOut.svg" v-else>
    </button>
    <div class=" wrap shadow">
      <button type="button"
              v-if="!maxScale"
              @mousedown="plusDown"
              @mouseup="plusUp"
              @mouseleave="plusUp"
              class="plus-icon control-btn">
        <img src="../../../../assets/plus.svg">
      </button>
      <button type="button"
              v-if="!minScale"
              @mousedown="minusDown"
              @mouseup="minusUp"
              @mouseleave="minusUp"
              class="minus-icon control-btn">
        <img src="../../../../assets/minus.svg">
      </button>
    </div>
  </div>
</template>

<script>
  import zoomIcon from '../../../Svg/projects/fieldControl/zoomIcon'
  import zoomOutIcon from '../../../Svg/projects/fieldControl/zoomOutIocn'
  import plusIcon from '../../../Svg/projects/fieldControl/plusIcon'
  import minusIcon from '../../../Svg/projects/fieldControl/minusIcon'
  import {mapState, mapMutations, mapGetters} from 'vuex'

  export default {
    name: 'projectTreeControls',
    components: {
      zoomIcon,
      plusIcon,
      minusIcon,
      zoomOutIcon
    },
    data() {
      return {
        plusClicked: false,
        minusClicked: false,
        field: '',
        motherWidth: '',
        motherHeight: '',
      }
    },
    computed: {
      ...mapState({
        showControls: state => state.projects.showControls,
        showZoom: state => state.projects.showZoom,
        showPlus: state => state.projects.showPlus,
        showMinus: state => state.projects.showMinus,
        scaleIndex: state => state.projects.scaleIndex,
        activeZoom: state => state.projects.activeZoom
      }),
      ...mapGetters({
        showZoomBtn: 'projects/showZoomBtn'
      }),
      minScale() {
        return +this.scaleIndex < 0.2
      },
      maxScale() {
        return +this.scaleIndex >= 1
      }
    },
    methods: {
      ...mapMutations({
        setScaleIndex: 'projects/SET_SCALE_INDEX',
        setActiveZoom: 'projects/SET_ACTIVE_ZOOM'
      }),
      setFieldLeftPosition() {
        //тк поле масштабируется, его реальные координаты смещаются.
        //нужно компенсировать это смещение
        const field = document.querySelector('.project-tree-cont');

        //чтобы не делать тяжелых dom операций, храним в стэйте
        if (!this.motherWidth) {
          this.motherWidth = document.querySelector('.project-tree-scrollwrap').clientWidth - 60;
        };
        if (!this.motherHeight) {
          this.motherHeight = document.querySelector('.project-tree-scrollwrap').clientHeight - 44;
        };
        //параметры материнского контейнера
        const motherWidth = this.motherWidth;
        const motherHeight = this.motherHeight;
        const fieldWidth = field.clientWidth;
        const fieldHeight = field.clientHeight;
        //коэффициент для уменьшения, чтобы все влезло в экран
        //здесь он постоянен для случаев, когда поле меньше родителя по горизонту
        const scale = (motherWidth / fieldWidth).toFixed(2);

        //смещение налево
        //если поле становится больше контейнера, ровняем по левому краю
        if (fieldWidth * this.scaleIndex > motherWidth) {
          let fieldSetLeft = ((fieldWidth * this.scaleIndex - fieldWidth) / 2 + 30).toFixed(0);
          field.style.left = fieldSetLeft + 'px';
        } else
        {
          //иначе ровняем посередине
          //разница между уменьшеной и полной длиной пополам + паддинги родителя
          let fieldSetLeft = ((fieldWidth * scale - fieldWidth) / 2 + 30).toFixed(0);
          field.style.left = fieldSetLeft + 'px';
        };

        //смещение вверх
        //тут нет случая, когда поле больше, тк макс масштаб 1
        let fieldSetTop = ((fieldHeight * this.scaleIndex - fieldHeight)/ 2 + 22).toFixed(0);
        field.style.top = fieldSetTop + 'px'
      },
      //увеличиваем масштаб
      plusScale() {
        this.setScaleIndex(+this.scaleIndex + .1);
        this.setFieldLeftPosition();
      },
      //кнопка плюс зажата
      plusDown() {
        this.plusClicked = true;
        this.plusScale();
        setTimeout(this.plusZoomInfinite, 1000)
      },
      //кнопка плюс отжата
      plusUp() {
        this.plusClicked = false
      },
      //увеличение для зажатой кнопки раз в 200мс
      plusZoomInfinite() {
        if (this.plusClicked) {
          plusZoom(this);

          function plusZoom(cnt) {
            if (cnt.plusClicked && !cnt.maxScale) {
              setTimeout(() => {
                cnt.plusScale();
                plusZoom(cnt)
              }, 200)
            }
          }
        }
      },
      //для минуса все так же
      minusScale() {
        this.setScaleIndex(+this.scaleIndex - .1);
        this.setFieldLeftPosition();
      },
      minusDown() {
        this.minusClicked = true;
        this.minusScale();
        setTimeout(this.minusZoomInfinite, 1000);
      },
      minusUp() {
        this.minusClicked = false
      },
      minusZoomInfinite() {
        if (this.minusClicked) {
          minusZoom(this);

          function minusZoom(cnt) {
            if (cnt.minusClicked && !cnt.minScale) {
              setTimeout(() => {
                cnt.minusScale();
                minusZoom(cnt)
              }, 200);
            }
          }
        }
      },
      elementsScale() {
        //поле с элементами
        const field = document.querySelector('.project-tree-cont');
        //материнский контейнер
        const mother = document.querySelector('.project-tree-scrollwrap');

        const fullScreen = document.querySelector('.project-body');

        if (this.activeZoom) {
          if (document.exitFullscreen) {
            //отображаем в полном режиме
            if (document.exitFullscreen) {
              document.exitFullscreen()
              fullScreen.classList.remove('fullscreen-body');
            }
          } else {
            //если fullScreen api не поддерживается

            //сжимем все до scale = 1
            this.setScaleIndex(1);
            field.style.left = 30 + 'px';
            field.style.top = 22 + 'px';
          };
        } else
        {
          //меняем кнопку
          if (fullScreen.requestFullscreen) {
            fullScreen.requestFullscreen();
            fullScreen.classList.add('fullscreen-body')
          }
           else {
            // если fullScreen api не поддерживается

            //длина контейнера
            const motherWidth = mother.clientWidth - 60;
            //ширина контейнера
            const motherHeight = mother.clientHeight - 44;
            //поле с деревом
            const fieldWidth = field.clientWidth;
            const fieldHeigth = field.clientHeight

            //коэффициент для уменьшения, чтобы все влезло в экран
            let scale = (motherWidth / fieldWidth).toFixed(2);

            //смещение налево
            //разница между уменьшеной и полной длиной пополам + паддинги родителя
            let fieldSetLeft = ((fieldWidth * scale - fieldWidth)/2 + 30).toFixed(0);
            //смещение вверха
            //та же самая разница, только для высоты
            let fieldSetTop = ((fieldHeigth * scale - fieldHeigth)/2 + 22).toFixed(0)
            field.style.left = fieldSetLeft + 'px';
            field.style.top = fieldSetTop + 'px';
            //устанавливаем scale для поля
            this.setScaleIndex(scale)
          }

        }
      },
      controlFullScreen() {
        const fullScreen = document.querySelector('.project-body');

        if (this.activeZoom) {
          this.setActiveZoom(false);
          fullScreen.classList.remove('fullscreen-body')
        } else {
          this.setActiveZoom(true);
          fullScreen.classList.add('fullscreen-body')
        }
      }
    },
    mounted() {
    document.addEventListener('fullscreenchange', this.controlFullScreen)
    },
    destroyed() {
      this.setScaleIndex(1);
      this.motherWidth = '';

     document.removeEventListener('fullscreenchange', this.controlFullScreen);
    }
  }
</script>

<style lang="scss" scoped>
.field-controls {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  right: 32px;
  bottom: 36px;
}

.control-btn {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: radial-gradient(142.35% 100% at 50% 0%, #FFFFFF 12.92%, #FBFCFD 50.11%, #E9F0F4 100%);
}

.shadow {
  box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
  border-radius: 8px;

}

.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: radial-gradient(142.35% 100% at 50% 0%, #FFFFFF 12.92%, #FBFCFD 50.11%, #E9F0F4 100%);

  .control-btn {
    background: none;
  }
}

.zoom-btn {
  margin-bottom: 10px;
}

.plus-icon {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background: #D2E0E8;
    opacity: 0.6;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    left: 8px;
    bottom: -1px;
  }
}

  img {
    width: auto;
  }
</style>
